import { v4 as uuidv4 } from 'uuid';

// In-memory only: unique per tab, not shared across tabs, not persisted to localStorage.
const _clientInstanceId: string = uuidv4();

/**
 * Get the in-memory client instance ID for this tab.
 * A new ID is generated on each page load and never written to localStorage,
 * ensuring each tab has its own independent session identity.
 */
export function fetchClientInstanceId(): string {
    return _clientInstanceId;
}
